export default __webpack_public_path__ + "static/media/IndividualTreatmentVisualisationBurst.8ac25cfb.svg";